module.exports = __webpack_public_path__ + "media/vid-tw-embed-code.cff1a430.webm";